import { intlNumberFormat } from "../helpers/intlNumberFormat"
import { useTranslation } from "../libs/react-i18next"

export const useNumberFormatter = ({ options }: { options: Intl.NumberFormatOptions }) => {
  const { i18n } = useTranslation()

  return intlNumberFormat({ locale: i18n.language, options }).format
}

export const useFormatDecimals = ({
  maxDecimalPlaces,
  minDecimalPlaces,
}: {
  maxDecimalPlaces: number
  minDecimalPlaces?: number
}) => {
  return useNumberFormatter({
    options: {
      style: "decimal",
      maximumFractionDigits: maxDecimalPlaces,
      minimumFractionDigits: minDecimalPlaces,
    },
  })
}

export const useFormatPercentage = ({ maxDecimalPlaces }: { maxDecimalPlaces: number }) => {
  return useNumberFormatter({
    options: {
      style: "percent",
      maximumFractionDigits: maxDecimalPlaces,
    },
  })
}
